var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasicLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.22791 27.7618L6.47055 26.3738L11.0294 28.4559L18.7794 23.5977L30.6323 25.4484",
  className: "chart-qualitative-03-stroke",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.22791 19.4337L4.53305 15.3851L7.8382 11.3366L13.3088 12.4934L22.4264 4.62768L30.1764 1.85156",
  className: "chart-qualitative-02-stroke",
  strokeWidth: 1.5,
  strokeLinecap: "square"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.45593 23.1344L7.90242 21.7463L13.3257 17.1195L22.8824 19.6642L30.6324 13.418",
  stroke: "#007AC9",
  strokeWidth: 1.5,
  strokeLinecap: "square"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 0V31H32",
  className: "chart-axis-line-stroke",
  strokeWidth: 1.5
})));
export { SvgBasicLine as ReactComponent };
export default __webpack_public_path__ + "basic_line.e86304409749a912ddfd508d6f6646ec.svg";